module.exports = __webpack_public_path__ + "static/media/3start.8f05a630.png";